import { create } from "zustand";
import { Transaction, Pagination } from "../api/types";

interface TransactionsState {
  transactions: Transaction[];
  pagination: Pagination | null;
  isLoading: boolean;
  loadingNextPage: boolean;
  initialFetchDone: boolean;
  error: string | null;
  pendingTxnAmount: number;
  // Internal methods for SDK use only
  _setTransactions: (transactions: Transaction[]) => void;
  _appendTransactions: (transactions: Transaction[]) => void;
  _setPagination: (pagination: Pagination) => void;
  _setLoading: (loading: boolean) => void;
  _setLoadingNextPage: (loading: boolean) => void;
  _setInitialFetchDone: (done: boolean) => void;
  _setError: (error: string | null) => void;
  _setPendingTxnAmount: (amount: number) => void;
  _reset: () => void;
}

export const useTransactionsStore = create<TransactionsState>((set) => ({
  transactions: [],
  pagination: null,
  isLoading: false,
  loadingNextPage: false,
  initialFetchDone: false,
  error: null,
  pendingTxnAmount: 0,

  // Internal methods for SDK use only (prefixed with _)
  _setTransactions: (transactions) => set({ transactions }),
  _appendTransactions: (newTransactions) =>
    set((state) => ({
      transactions: [...state.transactions, ...newTransactions],
    })),
  _setPagination: (pagination) => set({ pagination }),
  _setLoading: (loading) => set({ isLoading: loading }),
  _setLoadingNextPage: (loading) => set({ loadingNextPage: loading }),
  _setInitialFetchDone: (done) => set({ initialFetchDone: done }),
  _setError: (error) => set({ error }),
  _setPendingTxnAmount: (amount) => set({ pendingTxnAmount: amount }),
  _reset: () =>
    set({
      transactions: [],
      pagination: null,
      isLoading: false,
      loadingNextPage: false,
      initialFetchDone: false,
      error: null,
    }),
}));
